/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ForgotPasswordCommand
 */
export interface ForgotPasswordCommand {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordCommand
     */
    email: string;
}

/**
 * Check if a given object implements the ForgotPasswordCommand interface.
 */
export function instanceOfForgotPasswordCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function ForgotPasswordCommandFromJSON(json: any): ForgotPasswordCommand {
    return ForgotPasswordCommandFromJSONTyped(json, false);
}

export function ForgotPasswordCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForgotPasswordCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function ForgotPasswordCommandToJSON(value?: ForgotPasswordCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

